export default __webpack_public_path__ + "static/media/authorizer-icon.2b8f7a3d.svg";